import { matchPath } from "react-router-dom";

import { slugifyOrgName } from "./slugifyOrgName";

const DASHBOARD_PATH = `/orgs/:orgName/:sections*`;
/** Allows us to use generic 'orgs/-/:section' for all users, and still land them
in a valid url corresponding to one of their orgs. For example, if the user's org
is called abc and we send them to orgs/-/projects, they get forwarded to orgs/abc/projects.
This also works for org typos like returntocrp instead of returntocorp. */
export const replaceOrgInPath = (
  pathname: string,
  newOrgName: string
): string => {
  const match = matchPath<{ sections: string; orgName: string }>(pathname, {
    path: DASHBOARD_PATH,
  });
  if (match === null) return pathname;
  return `/orgs/${slugifyOrgName(newOrgName)}/${match.params.sections || ""}`;
};
